import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import axios from 'axios';

const SettingsContext = createContext();

export const useSettings = () => {
  const context = useContext(SettingsContext);
  if (!context) {
    throw new Error('useSettings must be used within a SettingsProvider');
  }
  return context;
};

const defaultSettings = {
  defaultPositionSize: 10,
  defaultCurrency: '$',
  defaultTags: [],
  notifications: false,
  twoFactorAuth: false,
};

export const SettingsProvider = ({ children }) => {
  const [settings, setSettings] = useState(() => {
    const saved = localStorage.getItem('tradingSettings');
    return saved ? { ...defaultSettings, ...JSON.parse(saved) } : defaultSettings;
  });

  useEffect(() => {
    localStorage.setItem('tradingSettings', JSON.stringify(settings));
  }, [settings]);

  const updateSetting = (key, value) => {
    setSettings(prev => ({ ...prev, [key]: value }));
  };

  const resetToDefaults = () => {
    setSettings(defaultSettings);
  };
  
  const refreshSettings = useCallback(async () => {
    try {
      const token = localStorage.getItem('idToken');
      if (!token) return;
      
      const response = await axios.get('https://v7jlylb599.execute-api.eu-west-1.amazonaws.com/usersettings', {
        headers: { Authorization: `Bearer ${token}` }
      });
      
      if (response.data) {
        // Update settings with fresh data from API
        setSettings(prev => ({
          ...prev,
          ...response.data
        }));
        console.log('Settings refreshed from API');
      }
    } catch (error) {
      console.error('Error refreshing settings:', error);
    }
  }, []);

  return (
    <SettingsContext.Provider value={{ settings, updateSetting, resetToDefaults, refreshSettings }}>
      {children}
    </SettingsContext.Provider>
  );
};